import styles from './result.module.scss';

const Result = ({ focused, handleClick, index, item, setFocused }) => {
    const { First_Name, Last_Name, Registration_Name, Gender, Profession } = item;

    const onMouseOver = () => {
        setFocused(index);
    };

    const isHighlighted = focused === index;

    return (
        <li className={styles.Result}>
            <button
                type="button"
                className={`${styles.ResultItem} ${isHighlighted ? styles.ResultActive : ''}`}
                onClick={() => handleClick(index)}
                onMouseOver={onMouseOver}
                onFocus={onMouseOver}
            >
                <div className={styles.topRow}>
                    <span className={styles.name}>
                        {First_Name} {Last_Name}
                    </span>

                    <span className={styles.gender}>{Gender}</span>
                </div>

                <div className={styles.bottomRow}>
                    <span className={styles.profession}>{Profession}</span>

                    <span className={styles.hcpc_reg_name}>{Registration_Name}</span>
                </div>
            </button>
        </li>
    );
};

export default Result;
